export default function BenefitsSection() {
  const benefits = [
    {
      icon: "ri-price-tag-3-line",
      title: "Better Price Tracking",
      desc: "The Mulebuy spreadsheet system organizes pricing data clearly so you can spot the best deals instantly.",
    },
    {
      icon: "ri-layout-grid-line",
      title: "Organized Product Listings",
      desc: "14 well-structured categories make browsing the Mulebuy spreadsheet intuitive and efficient.",
    },
    {
      icon: "ri-scales-3-line",
      title: "Easier Comparison",
      desc: "Side-by-side spreadsheet format lets you compare products, prices, and features at a glance.",
    },
    {
      icon: "ri-flashlight-line",
      title: "Faster Decision-Making",
      desc: "The streamlined Mulebuy spreadsheet interface reduces browsing time and speeds up purchase decisions.",
    },
    {
      icon: "ri-eye-line",
      title: "Spreadsheet Transparency",
      desc: "All product information is presented openly in the Mulebuy spreadsheet with no hidden costs.",
    },
    {
      icon: "ri-global-line",
      title: "Western Shopper Friendly",
      desc: "Designed specifically for European and Western buyers who value data-driven shopping.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
          Why the Mulebuy Spreadsheet Is Popular in 2026
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-xl">
          Discover the key advantages that make the Mulebuy spreadsheet method the preferred choice for modern shoppers.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((item) => (
            <div key={item.title} className="bg-background-50 rounded-lg p-6 md:p-7 hover:bg-background-100 transition-colors duration-200">
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="mt-4 font-semibold text-foreground-950 text-base">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}